import PageShell from "@/components/PageShell";
import { Membresias } from "@/components/landing/Membresias";

export default function MembresiasPage() {
  return (
    <PageShell crumbs={[{ label: "Socios" }]}>
      <Membresias />
    </PageShell>
  );
}
